import React from 'react';
import { styled } from '@linaria/react';
import { SkeletonLoader } from '@daedalus/atlas/SkeletonLoader';
import { OfferLayoutBaseProps, OfferLayoutLoadingProps } from '.';
export const Wrapper = /*#__PURE__*/styled('div')({
  name: "Wrapper",
  class: "wre2hti",
  propsAsIs: false
});
const RightInnerWrapper = /*#__PURE__*/styled('div')({
  name: "RightInnerWrapper",
  class: "r1vkkd2t",
  propsAsIs: false
});
export const RightWrapper = /*#__PURE__*/styled('div')({
  name: "RightWrapper",
  class: "r10k299o",
  propsAsIs: false
});
type Props = Omit<OfferLayoutBaseProps, 'tagComponent'>;
export const SecondaryDefaultLayout: React.FC<Props | OfferLayoutLoadingProps> = ({
  isLoading,
  priceComponent,
  providerLogoComponent,
  roomLabelsComponent,
  ctaComponent,
  cashbackComponent,
  className,
  dataId
}) => {
  if (isLoading) return <Wrapper>
        <SkeletonLoader width={120} height={20} />
        <SkeletonLoader width={45} height={20} marginTop={0} />
      </Wrapper>;
  return <Wrapper className={className} data-id={dataId}>
      <div>
        {providerLogoComponent}
        {roomLabelsComponent}
      </div>
      <RightWrapper>
        <RightInnerWrapper>
          {priceComponent}
          {cashbackComponent}
        </RightInnerWrapper>
        {ctaComponent}
      </RightWrapper>
    </Wrapper>;
};

require("./SecondaryDefaultLayout.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./SecondaryDefaultLayout.tsx");